import * as requestFromServer from "./TimeTableCrud";
import { timetableSlice } from "./TimeTableSlice";

const {actions} = timetableSlice;

export const getCurrentTimetable = () => async dispatch => {
  dispatch(actions.startCall());  
  return requestFromServer
    .getCurrentTimetable()
    .then(response => {
      dispatch(actions.currentTimetableFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getCoursesAndTeachers = () => async dispatch => {
  dispatch(actions.startCall());  
  return requestFromServer
    .getCoursesAndTeachers()
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getList = () => async dispatch => {
  dispatch(actions.startCall());  
  return requestFromServer
    .getList()
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllTimetable = (term, semester) => async dispatch => {
  dispatch(actions.startCall());  
  return requestFromServer
    .getAllTimetable(term, semester)
    .then(response => {
      dispatch(actions.allTimetableFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getTeachersAndTimetable = (tableType, term, semester, tableId) => async dispatch => {
  dispatch(actions.startCall());  
  return requestFromServer
    .getTeachersAndTimetable(tableType, term, semester, tableId)
    .then(response => {
      dispatch(actions.teachersAndTimetableFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getTimetable = (tableType, term, semester, tableId) => async dispatch => {
  dispatch(actions.startCall());  
  return requestFromServer
    .getTimetable(tableType, term, semester, tableId)
    .then(response => {
      dispatch(actions.timetableFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const saveAllTimetable = timeTable => async dispatch => {
  dispatch(actions.startCall());
  return requestFromServer
    .saveAllTimetable(timeTable)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const saveTimetable = timeTable => async dispatch => {
  dispatch(actions.startCall());
  return requestFromServer
    .saveTimetable(timeTable)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const transferTimetable = timeTable => async dispatch => {
  dispatch(actions.startCall());
  return requestFromServer
    .transferTimetable(timeTable)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const deleteTimetable = timetable => async dispatch => {
  dispatch(actions.startCall());
  return requestFromServer
    .deleteTimetable(timetable)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const startAction = () => dispatch => {
  dispatch(actions.startCall());
}

export const completeAction = () => dispatch => {
  dispatch(actions.actionCompleted());
}

export const cleanTimetableState = () => dispatch => {
  dispatch(actions.timetableStateCleaned());
}